import { isArray, isObject, isFunction, isDate } from './_'

export const pad = (val, len, char = '0') => {
  val = val !== null && val !== undefined ? String(val) : ''
  len = len || 2
  while (val.length < len) {
    val = `${char}${val}`
  }
  return val
}

export const evalFn = (fn, args) => (isFunction(fn) ? fn(args) : fn)

export const mergeEvents = (...args) => {
  const result = {}
  args.forEach(e =>
    Object.entries(e).forEach(([key, value]) => {
      if (!result[key]) {
        result[key] = value
      } else if (isArray(result[key])) {
        result[key].push(value)
      } else {
        result[key] = [result[key], value]
      }
    }),
  )
  return result
}

export const pageIsValid = page => !!(page && page.month && page.year)

export const pageIsBeforePage = (page, comparePage) => {
  if (!pageIsValid(page) || !pageIsValid(comparePage)) return false
  if (page.year === comparePage.year) return page.month < comparePage.month
  return page.year < comparePage.year
}

export const pageIsAfterPage = (page, comparePage) => {
  if (!pageIsValid(page) || !pageIsValid(comparePage)) return false
  if (page.year === comparePage.year) return page.month > comparePage.month
  return page.year > comparePage.year
}

export const pageIsBetweenPages = (page, fromPage, toPage) =>
  (page || false) &&
  !pageIsBeforePage(page, fromPage) &&
  !pageIsAfterPage(page, toPage)

export const pageIsEqualToPage = (aPage, bPage) => {
  if (!aPage && bPage) return false
  if (aPage && !bPage) return false
  if (!aPage && !bPage) return true
  return aPage.month === bPage.month && aPage.year === bPage.year
}

export const addPages = ({ month, year }, count) => {
  const incr = count > 0 ? 1 : -1
  for (let i = 0; i < Math.abs(count); i++) {
    month += incr
    if (month > 12) {
      month = 1
      year++
    } else if (month < 1) {
      month = 12
      year--
    }
  }
  return {
    month,
    year,
  }
}

export const pageRangeToArray = (from, to) => {
  if (!pageIsValid(from) || !pageIsValid(to)) return []
  const result = []
  while (!pageIsAfterPage(from, to)) {
    result.push(from)
    from = addPages(from, 1)
  }
  return result
}

export function datesAreEqual(a, b) {
  const aIsDate = isDate(a)
  const bIsDate = isDate(b)
  if (!aIsDate && !bIsDate) return true
  if (aIsDate !== bIsDate) return false
  return a.getTime() === b.getTime()
}

export const arrayHasItems = array => isArray(array) && array.length

export const mixinOptionalProps = (source, target, props) => {
  const assigned = []
  props.forEach(p => {
    const name = p.name || p.toString()
    const mixin = p.mixin
    const validate = p.validate
    if (Object.prototype.hasOwnProperty.call(source, name)) {
      const value = validate ? validate(source[name]) : source[name]
      target[name] = mixin && isObject(value) ? { ...mixin, ...value } : value
      assigned.push(name)
    }
  })
  return {
    target,
    assigned: assigned.length ? assigned : null,
  }
}

export const on = (element, event, handler, opts) => {
  if (element && event && handler) {
    element.addEventListener(event, handler, opts)
  }
}

export const off = (element, event, handler, opts) => {
  if (element && event) {
    element.removeEventListener(event, handler, opts)
  }
}

export const elementContains = (element, child) =>
  !!element && !!child && (element === child || element.contains(child))

export const onSpaceOrEnter = (event, handler) => {
  if (event.key === ' ' || event.key === 'Enter') {
    handler(event)
    event.preventDefault()
  }
}

/* eslint-disable no-bitwise */

export const createGuid = () => {
  function S4() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
  }
  return `${S4() + S4()}-${S4()}-${S4()}-${S4()}-${S4()}${S4()}${S4()}`
}

export function hash(str) {
  let hashcode = 0
  let i = 0
  let chr
  if (str.length === 0) return hashcode
  for (i = 0; i < str.length; i++) {
    chr = str.charCodeAt(i)
    hashcode = (hashcode << 5) - hashcode + chr
    hashcode |= 0 // Convert to 32bit integer
  }
  return hashcode
}

export const isMenuOnlineOrder = (order) => {
  return order.order_id != null
}

// posOrder to OrderRef
export const transformOrderRef = (order) => {
  return {
    sku_id: order.sku_id,
    price: order.price,
    item: order.item,
    attributes: order.attributes.map((attr) => ({
      name: attr.name,
      option: attr.option,
    })),
    modifiers: order.modifiers.map((modifier) => {
      return {
        modifier_id: modifier.modifier_id,
        options: modifier.options.map((option) => {
          return {
            option_id: option.modifieroption_id,
            name: option.option,
            price: option.price,
          }
        }),
      }
    }),
    discounts: order.discounts.map((discount) => {
      return {
        discount_id: discount.discount_id,
        value_type: discount.value_type,
        value_amount: discount.value_amount,
      }
    }),
    taxes: order.taxes.map((tax) => {
      return {
        amount: tax.amount,
        form_type: tax.form_type,
        name: tax.tax_name,
        tax_id: tax.tax_id,
        type: tax.type,
      }
    }),
    note: order.note || null,
    quantity: order.quantity,
    customer_id: order.customer_id || null,
    queue_number: `${order.queue_number}`,
    table_number: `${order.table_number}`,
  }
}

export const getSkuNameWithUnit = (name, unit) => {
  let result = name
  if (unit) result += ` - ${unit}`
  return result
}

/* eslint-enable no-bitwise */



// WEBPACK FOOTER //
// ./src/lib/v-calendar/utils/helpers.js